import * as _ from 'lodash-es';
import { MultiLangString } from './lingua_sistema';

export class Deserializable {
    deserialize(input: any) {
        // Object.assign(this, input);

        
        return _.assignInWith(this, input, (objValue, srcValue) => {
            // console.log(objValue, srcValue, key, object, source);
            if (srcValue == null) return null;

            if (typeof (srcValue == 'object') && srcValue['it'] != null) {
                const res = _.assignInWith(new MultiLangString(), srcValue);
                return res;
            }
            return srcValue;
        });
    }
}

export interface HmModel {
    id: number;
}

export abstract class HmModelRestNoName extends Deserializable implements HmModel {
    static readonly rest_path: string;

    abstract id: number;

    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    get enum() { return [this.id]; }
    get description() { return this.getLabel(); }

    get value(): any {
        return this.id;
    }

    get title(): any {
        return this.id;
    }

    getLabel(lang: string = 'it'): string {
        return '' + this.id;
    }

}


// per ora typescript non supporta i metodi statici in interfaccia
// https://github.com/Microsoft/TypeScript/issues/14600

export class HmModelRest extends HmModelRestNoName {
    static readonly rest_path: string;

    id: number;
    nome?: string | MultiLangString;


    get value(): number {
        return this.id;
    }

    getLabel(lang: string = 'it'): string {
        if (typeof (this.nome) == 'string') {
            return this.nome;
        }

        if (this.nome instanceof MultiLangString) {
            return (this.nome as MultiLangString).getValue(lang)
                ;
        }
        if (this.nome)
            return this.nome[lang] || this.nome['it'];

        return null;
    }

    get title(): string {
        return this.getLabel();
    }
}


export type HmType<T> = new() => T;

export interface HmRestType<T> { new(): T; rest_path; }




